// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CallPendingDisplay_wrapper__2C4Pd","remove-call":"CallPendingDisplay_remove-call__3P_8V"};